import dynamic from "next/dynamic";
export default dynamic(function () {
  return import(".");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak(".")];
    },
    modules: ["../components/keybinds-cheatsheet/lazy.ts -> " + "."]
  }
});